var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuperAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55649 7.56396L14.0444 18.0499H4.87467L2.55649 7.56396Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4109 7.56396L9.92306 18.0499H19.0928L21.4109 7.56396Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1639 5.19434L18.7321 18.0497H5.59572L12.1639 5.19434Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81818 18.6816H19.1364V20.9998H4.81818V18.6816Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5455 4.36364C13.5455 5.11675 12.935 5.72727 12.1818 5.72727C11.4287 5.72727 10.8182 5.11675 10.8182 4.36364C10.8182 3.61052 11.4287 3 12.1818 3C12.935 3 13.5455 3.61052 13.5455 4.36364Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72727 6.682C3.72727 7.43511 3.11675 8.04563 2.36364 8.04563C1.61052 8.04563 1 7.43511 1 6.682C1 5.92888 1.61052 5.31836 2.36364 5.31836C3.11675 5.31836 3.72727 5.92888 3.72727 6.682Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0908 6.682C23.0908 7.43511 22.4803 8.04563 21.7272 8.04563C20.974 8.04563 20.3635 7.43511 20.3635 6.682C20.3635 5.92888 20.974 5.31836 21.7272 5.31836C22.4803 5.31836 23.0908 5.92888 23.0908 6.682Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperAdmin);
export default __webpack_public_path__ + "static/media/super-admin.a9495e9d5411c1ba9642f4db1309b7e8.svg";
export { ForwardRef as ReactComponent };